import type { SubscriptionType } from './types/subscription';
import {
  B2C_HOSTING_TYPES,
  B2C_ECOMMERCE_TYPES,
  WL_HOSTING_TYPES,
  WL_ECOMMERCE_TYPES,
} from './constants/subscription-type';

const priorityConfigurationsStorage = new Map<
  SubscriptionType[],
  Record<SubscriptionType, number>
>();

const prioritizer = {
  get(collection: SubscriptionType[]): Record<string, number> {
    if (priorityConfigurationsStorage.has(collection)) {
      // eslint-disable-next-line yola/@typescript-eslint/no-non-null-assertion
      return priorityConfigurationsStorage.get(collection)!;
    }

    return prioritizer.set(collection);
  },

  getPriority(item: SubscriptionType): number {
    let result: number | undefined;

    priorityConfigurationsStorage.forEach((configuration) => {
      if (item in configuration) {
        result = configuration[item];
      }
    });

    return result === undefined ? -1 : result;
  },

  set(collection: SubscriptionType[]): Record<string, number> {
    const priorities = this.calculatePriorities(collection);

    priorityConfigurationsStorage.set(collection, priorities);

    return priorities;
  },

  calculatePriorities(collection: SubscriptionType[]): Record<string, number> {
    return collection.reduce<Record<string, number>>(
      (
        result: Record<SubscriptionType, number>,
        subscription: SubscriptionType,
        index: number
      ) => ({
        ...result,
        [subscription]: index,
      }),
      {}
    );
  },
};

prioritizer.set(B2C_HOSTING_TYPES);
prioritizer.set(WL_HOSTING_TYPES);
prioritizer.set(B2C_ECOMMERCE_TYPES);
prioritizer.set(WL_ECOMMERCE_TYPES);

export default prioritizer;
